export default __webpack_public_path__ + "alberta-resend.31a939cabc798e44ba33.svg";